export { default } from './EligibilityFactorsCard'
